import React from 'react';
import { Card, Grid, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

function SelectOptionLayout({ sidebar, body }) {
  return (
    <Grid container spacing={2}>
      <Grid item container xs={12} md={3}>
        <Card sx={{ width: '100%' }}>{sidebar}</Card>
      </Grid>
      <Grid item container xs={12} md={9}>
        <Card sx={{ padding: '15px', width: '100%' }}>{body}</Card>
      </Grid>
    </Grid>
  );
}

export default SelectOptionLayout;

export function SideItem({ text, action, priorityAction, section, icon }) {
  return (
    <ListItem>
      <ListItemButton onClick={priorityAction ? () => priorityAction() : () => action(section)}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={text} />
      </ListItemButton>
    </ListItem>
  );
}
